import { useEffect, useState } from 'react';
import { fetchLicenseStatus } from '../../services/platformApi';
import { usePermissions } from '../../contexts/PermissionsContext';
import { LicenseStatus } from '../../types/LicenseStatus';

export function TopHeaderCompanyInfo() {
  const { access } = usePermissions();
  const [license, setLicense] = useState<LicenseStatus | null>(null);

  useEffect(() => {
    void fetchLicenseStatus()
      .then(setLicense)
      .catch(() => setLicense(null));
  }, []);

  const companyName = license?.companyName || 'Empresa';
  const planCode = license?.planCode || '—';
  const licenseStatus = license?.displayStatus || '—';
  const profileLabel =
    access?.roleCodes?.includes('admin')
      ? 'Executivo'
      : access?.roleCodes?.includes('marketing')
        ? 'Marketing'
        : access?.roleCodes?.join(', ') || 'Operacional';

  return (
    <div className="min-w-0 flex-1 px-2 lg:px-4">
      <p className="truncate text-sm font-semibold text-secondary-900 sm:text-base">{companyName}</p>
      <p className="hidden truncate text-xs text-secondary-500 sm:block">
        Plano: {planCode} · Licença: {licenseStatus} · Perfil: {profileLabel}
      </p>
      <p className="truncate text-xs text-secondary-500 sm:hidden">
        {planCode} · {profileLabel}
      </p>
    </div>
  );
}
